<template>
  <v-card flat color="rgb(243, 245, 248, .4)">
    <v-card-title class="d-flex justify-space-between align-center">
      <h3 class="titleText--text">Split Variable</h3>
      <v-btn icon color="blue" title="Create New  Dummy Variables">
        <v-icon
          @click="handleAddVariable()"
          >mdi-plus-circle</v-icon
        >
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-simple-table v-if="listofSavedSplitVariables.length">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center titleText--text font-weight-bold">Variable</th>
              <th class="text-center titleText--text font-weight-bold">SplitName</th>
              <th class="text-center titleText--text font-weight-bold">Region</th>
              <th class="text-center titleText--text font-weight-bold">Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in listofSavedSplitVariables" :key="item.id">
              <td class="titleText--text font-weight-bold text-center">{{ item.variable }}</td>
              <td class="titleText--text font-weight-bold text-center">{{ item.var_name }}</td>
              <td class="darkGrey--text text-capitalize text-center">{{ item.region_param.join('') }}</td>
              <td class="darkGrey--text text-center">{{ item.date_param.join(', ') }}</td>
              <td class="text-right">
                <v-icon
                  @click="OpenEditWindow(item)"
                  title="Edit Variable"
                  color="titleText"
                  >mdi-pencil-outline</v-icon
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <p class="text-center titleText--text" v-else>No variables found</p>
      <ctrSplitVariableEdit ref="refctrSplitVariableEdit" @onLoad="CallOnload()"></ctrSplitVariableEdit>
    </v-card-text>
  </v-card>
</template>
<script>
import apifactory from "../api";
import ctrSplitVariableEdit  from "../views/ctrSplitVariableEdit.vue";

export default {
  components: {ctrSplitVariableEdit},
  data: () => ({
    listofSavedSplitVariables: [],
    headers: [
      {
        text: "Variable",
        align: "start",
        value: "variable",
        groupable: true,
      },
      { text: "var_name", value: "var_name", align: "right", groupable: false },
      {
        text: "region_param",
        value: "region_param",
        align: "right",
        groupable: true,
      },
      {
        text: "date_param",
        value: "date_param",
        align: "right",
        groupable: false,
      },
      { text: "Action", align: "right", groupable: false },
    ],
  }),
  methods: {
    handleAddVariable () {
      this.$emit('onAddVariable')
    },
    OpenEditWindow(varitem) {
      this.$refs.refctrSplitVariableEdit.CallOnload(varitem);
    },
    CallOnload() {
      this.call_api_get_var_split();
    },
    call_api_get_var_split() {
      //   alert('call_api_get_var_split');
      apifactory
        .api_get_var_split()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            //alert(JSON.stringify( res.data));
            this.listofSavedSplitVariables = res.data.all_variable_splits;
            //variablelist
          }
        })
        .catch(function (error) {
          alert("call_api_save_var_split" + error);
          // return false;
        });
    },
  },
  computed: {},

  mounted() {
    this.call_api_get_var_split();
  },
};
</script>
<style scoped>
.scroll {
  overflow-y: scroll;
}
.vtoolbar {
  height: 40px !important;
}
.vtoolbartitle {
  font-size: 15px !important;
  margin-left: 3% !important;
  height: 40px !important;
  text-align: center !important;
}
.listtext {
  text-align: left !important;
}
table td {
  border: none !important;
}

table thead, table tr {
  border: none !important
}
</style>
